import { Link } from 'gatsby';
import NavButtons from 'components/Advanced_User/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import DangerBoxURL from 'components/1440p_Series_CGI_List/DangerBoxURL';
import PrimaryBox from 'components/1440p_Series_CGI_List/PrimaryBoxH265Warning';
import { EuiSpacer } from '@elastic/eui';
import * as React from 'react';
export default {
  Link,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  DangerBoxURL,
  PrimaryBox,
  EuiSpacer,
  React
};